import { startOfWeek, momentFromDate } from '../../../week'

// We have __valid__ as a key in the values, (so we need to ignore them)
const inValidKeys = ['__valid__', 'gov_id']

export const minOneKey = values =>
  Object.keys(values).filter(value => (inValidKeys.includes(value) ? false : values[value]))
    .length > 0

const ccsStarted = momentFromDate('2018-07-02')

export const afterCCSStarted = ({ week_start_date }) => ccsStarted.isSameOrBefore(week_start_date)

export const validateCCSStartDate = ({ week_start_date }) => {
  const startDate = momentFromDate(week_start_date)
  const startOfThisWeek = startOfWeek()

  if (startDate.isAfter(startOfThisWeek)) {
    return false
  }

  if (ccsStarted.isAfter(startDate)) {
    return false
  }

  return true
}

export const validCCSClaimRange = ({ week_start_date }) => {
  const startDate = momentFromDate(week_start_date)

  if (startDate.isSameOrAfter(startOfWeek())) {
    return false
  }

  if (startDate.isBefore(ccsStarted)) {
    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./src/provider-level/reports/reports/helpers.js